import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const MiraiNewsAllPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  const [newsData, setNewsData] = useState([]); // State for storing news data
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [totalPages, setTotalPages] = useState(1); // Total pages from backend
  const [loading, setLoading] = useState(false); // Loading state

  const fetchNews = async (page) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://mirai-server.vercel.app/news-home-data?page=${page}`
      );
      const { data, pages } = response.data; // Destructure response data

      setNewsData(data); // Update news data state
      setTotalPages(pages); // Update total pages
      setLoading(false);
    } catch (error) {
      console.error("Error fetching news data:", error);
      setLoading(false);
    }
  };

  // Fetch data when the component mounts or currentPage changes
  useEffect(() => {
    fetchNews(currentPage);
  }, [currentPage]);

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div className="py-20 min-h-screen border-t border-blue-200">
      <div className="w-full max-w-screen-2xl mx-auto p-4">
        <h1 className="text-5xl font-semibold font-jost customBlue">Column</h1>
        <div className="w-full mt-10">
          {loading ? (
            <p>Loading...</p>
          ) : (
            newsData.map((item, index) => (
              <Link to={`/news-details/${item._id}`} key={index}>
                <div>
                  <h1 className="text-xl flex justify-between font-semibold font-jost text-blue-900 w-full hover:bg-blue-100 hover:px-6 duration-300 ease-in-out py-6 border-b border-blue-500">
                    {item.title}
                    <span className="text-sm font-normal font-jost text-blue-500">
                      Posted Date: {new Date(item.createdAt).toDateString()}
                    </span>
                  </h1>
                </div>
              </Link>
            ))
          )}
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-end mt-6">
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            className="px-4 py-2  bg-blue-500 font-jost text-sm text-white rounded disabled:opacity-50"
          >
            Previous
          </button>
          <span className="px-4 py-2  font-jost text-sm bg-blue-50">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="px-4 py-2  bg-blue-500 font-jost text-sm text-white rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiraiNewsAllPage;
